import InputField from "../../applicationUi/components/intake/InputField";
import TextAreaField from "../../applicationUi/components/intake/TextAreaField";

const DailyProgramSection = ({ formData, handleChange, isReadOnly = false }) => (
  <section className="space-y-8">
    <div className="space-y-2">
      <h2 className="text-xl font-semibold text-foreground">Child's Daily Program</h2>
      <p className="text-sm text-muted-foreground">
        Information about the child's current educational or care setting.
      </p>
    </div>
    <InputField
      label="Program Type (eg. childcare, nursey, home, school)"
      name="dailyProgram.dailyProgram"
      value={formData.dailyProgram.dailyProgram}
      onChange={handleChange}
      readOnly={isReadOnly}
    />
    <TextAreaField
      label="Person/Agency/School Name"
      name="dailyProgram.dailyProgramName"
      value={formData.dailyProgram.dailyProgramName}
      onChange={handleChange}
      readOnly={isReadOnly}
    />

    <TextAreaField
      label="Overall Performance"
      name="dailyProgram.programPerformance"
      value={formData.dailyProgram.programPerformance}
      onChange={handleChange}
      readOnly={isReadOnly}
    />
    <TextAreaField
      label="Specific Difficulties"
      name="dailyProgram.specificDifficulties"
      value={formData.dailyProgram.specificDifficulties}
      onChange={handleChange}
      readOnly={isReadOnly}
    />

    <TextAreaField
      label="School attending"
      name="dailyProgram.schoolAttending"
      value={formData.dailyProgram.schoolAttending}
      onChange={handleChange}
      readOnly={isReadOnly}
    />
    <TextAreaField
      label="Current Grade"
      name="dailyProgram.currentGrade"
      value={formData.dailyProgram.currentGrade}
      onChange={handleChange}
      readOnly={isReadOnly}
    />
  </section>
);

export default DailyProgramSection;
